import { showDialog } from '../reducers/app';
import { setupEditMacroDialog } from '../reducers/edit_macro_dialog';
export function newMacro() {
    return (dispatch) => {
        dispatch(setupEditMacroDialog({
            title: '',
            active: false,
            items: []
        }));
        dispatch(showDialog('macro-edit'));
    };
}
